/* MAIN */
const isElement = (value) => {
    return (typeof value === 'object' && value !== null && value.nodeType === 1);
};
/* EXPORT */
export { isElement };
